import Vue from 'vue';
import Vuex from 'vuex';
import { AcaciaModules } from '@produtos/vue-acacia-plugin';

import AccessProvider from './modules/access_provider';
import SettingProvider from './modules/setting_provider';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...AcaciaModules,
    AccessProvider,
    SettingProvider,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js